import { render, staticRenderFns } from "./WaterOnPaperDryMassSection.vue?vue&type=template&id=4fb9d764&scoped=true&"
import script from "./WaterOnPaperDryMassSection.vue?vue&type=script&lang=js&"
export * from "./WaterOnPaperDryMassSection.vue?vue&type=script&lang=js&"
import style0 from "./WaterOnPaperDryMassSection.vue?vue&type=style&index=0&id=4fb9d764&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb9d764",
  null
  
)

export default component.exports